/******************************* 系统管理-权限表 *******************************/
import request from "@/utils/request";

/**
 * @description 查询岗位对应菜单
 * @param {string} [data.postId]
 * @param {string} [data.os] - 系统标识
 * @param {number} [data.types] - 权限类型
 */
export function permList(data) {
  return request({
    url: "/upms/perm/key/list",
    method: "post",
    data,
  });
}

/**
 * @description 查看权限
 * @param {string} [data.postId]
 * @param {string} [data.os] - 系统标识
 * @param {number} [data.types] - 权限类型
 */
export function permDetail(data) {
  return request({
    url: "/upms/post/perm/list",
    method: "post",
    data,
  });
}

/**
 * @description 分配菜单权限
 * @param {string} data.postId
 * @param {string} [data.os] - 系统标识
 * @param {{permId: string, type: number}[]} [data.permList]
 */
export function insertPerm(data) {
  return request({
    url: "/upms/post/perm/edit",
    method: "post",
    data,
  });
}
